import { Info2Icon } from 'components/icons';
import { Modal } from 'components/index';
import { ROUTES } from 'utils/constants/constants_routes';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from 'components/atoms/Button/Button';
import Link from 'components/atoms/Link/Link';
import React from 'react';
import styles from './TinkCredentialsFailedModal.module.scss';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export default function TinkCredentialsFailedModal({ isOpen, onClose }: Props) {
  const { t } = useTranslation('tink_credentials_failed_modal');
  const navigate = useNavigate();

  const handleNavigateDocuments = () => {
    navigate(ROUTES.FIRST_LOAN_ONLINE_BANK_ADD_DOCUMENTS);
  };

  const handleLater = () => {
    navigate(ROUTES.FIRST_LOAN_TINK_LATER);
  };

  return (
    <Modal
      className={styles.modal}
      classNameContent={styles.content}
      isOpen={isOpen}
      dataTest="tinkCredentialsFailedModal"
    >
      <div
        className={styles.container}
        data-testid="tink-credentials-failed-modal"
      >
        <Info2Icon
          className={styles['info-icon']}
          data-testid="tink-credentials-failed-modal-info-icon"
        />
        <div data-testid="tink-credentials-failed-modal-title">
          <div
            data-testid="tink-credentials-failed-modal-title-text"
            className={styles.title}
          >
            {t('title')}
          </div>
        </div>
        <div
          className={styles.subtitle}
          data-testid="tink-credentials-failed-modal-subtitle"
        >
          {t('subtitle')}
        </div>
        <Button
          fill
          dataTest="tink-credentials-failed-modal-documents-btn"
          onClick={handleNavigateDocuments}
        >
          {t('btn_documents')}
        </Button>
        <div
          className={styles['later-hint']}
          data-testid="tink-credentials-failed-modal-later-hint"
        >
          {t('btn_later_hint')}
        </div>
        <Button
          fill
          outlined
          dataTest="tink-credentials-failed-modal-later-btn"
          onClick={handleLater}
        >
          {t('btn_later')}
        </Button>
        <div
          className={styles['retry-section']}
          data-testid="tink-credentials-failed-modal-retry-section"
        >
          <div
            data-testid="tink-credentials-failed-modal-retry-hint"
            className={styles['retry-text']}
          >
            {t('retry_hint')}
          </div>
          <Link
            onClick={onClose}
            dataTest="tink-credentials-failed-modal-retry-link"
            className={styles['retry-link']}
          >
            {t('retry_link')}
          </Link>
        </div>
      </div>
    </Modal>
  );
}
